import { GetterTree } from 'vuex'
import { RootState } from '@/store/types/storeGlobalTypes'
import { EndpointState } from '@/store/modules/endpoint/endpointTypes'

export const getters: GetterTree<EndpointState, RootState> = {
  getEndpoints: (state) => (entityType: number) => {
    return state.endpoints[entityType]
  }
}
